import React from 'react';
import { Logo } from '@americanexpress/dls-react';
function NavMenu() {
  

    return (
        <div className="row">
            <div className="col-md-offset-1 col-md-10">
                <div className="nav nav-large nav-menu-section border flex flex-justify-end">
                    <nav className="nav nav-horizontal nav-header nav-large nav-sticky border nav-chevron" data-toggle="nav" data-responsive="true">
                        <div className="nav-overlay"></div>
                        <div className="nav-brand">
                            <Logo styleType="bluebox-solid" size="md" alt="blue box medium" />
                        </div>
                        <button className="nav-burger hidden-md-up dls-bright-blue" aria-label="Toggle navigation" aria-haspopup="true" aria-expanded="false">
                        </button>
                        <ul className="nav-menu">
                            <li className="nav-item">
                                <a className="nav-link" href="/Home">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/Home/creditcard">All Cards</a>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link caret" aria-current="false" aria-expanded="false" aria-haspopup="true">Card by type</button>
                                <div className="nav-menu shadow-1-md-up">
                                    <div className="nav-menu-section">
                                        <ul>
                                            <li className="nav-item">
                                                <a className="nav-link" href="/Home/ChargeCard">Charge</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="/Home/creditcard?preferences=credit">Credit</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="/Home/rewardscard">Reward</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="/Home/travelcard">Travel</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/Home/comparecards">Compare Cards</a>
                            </li>
                        </ul>


                    </nav>

                </div>
            </div>
        </div>
    );
}
export default NavMenu;